import globalTranslations from 'app-pages/_global/translations/en-US.json';
import { AccountPageTranslations } from 'app-pages/pages/account/translations/AccountTranslations';
import { UpdateChildTranslations } from 'app-pages/pages/account/translations/UpdateChildTranslations';
import { PatientVitalsTranslations } from 'app-pages/pages/consult/translations/PatientVitalsTranslations';
import { VideoRecordTranslations } from 'app-pages/pages/consult/video/translations/VideoRecordTranslations';
import { AccountCreateTranslations } from 'app-pages/pages/login/translations/AccountCreateTranslations';
import { MessagingTranslations } from 'app-pages/pages/messaging/translations/MessagingTranslations';
import { Locale } from 'components/core/locale/types';
import { FCWithChildren } from 'helpers/types/FCWithChidren';
import { IntlProvider } from 'use-intl';

import { PageMessages } from './intl.types';

const messages: PageMessages = {
  [Locale.English]: {},
};

function mergeMessages(...messagObjects: PageMessages[]) {
  messagObjects.forEach(messageObject => {
    for (const key in messageObject) {
      const k = key as Locale;
      if (!messages[k]) messages[k] = {};
      messages[k] = {
        ...messages[k],
        ...messageObject[k],
      };
    }
  });
}

mergeMessages(
  { [Locale.English]: globalTranslations },
  AccountPageTranslations,
  AccountCreateTranslations,
  MessagingTranslations,
  PatientVitalsTranslations,
  UpdateChildTranslations,
  VideoRecordTranslations,
);

export const InternationalizationProvider: FCWithChildren<{}> = ({
  children,
}) => (
  <IntlProvider messages={messages[Locale.English]} locale="en">
    {children}
  </IntlProvider>
);
